import { Logo as LogoSVG } from '../../Logo';
import { LogoContainer } from './HeaderRedesign.style';
import { BaseLink } from './navigation/HeaderRedesignBaseLink';
import styled from 'styled-components';

const Logo = styled(LogoSVG)`
  width: 6.5rem;
`;

export const HeaderLogo = () => {
  return (
    <LogoContainer>
      <BaseLink href="/">
        <Logo />
      </BaseLink>
    </LogoContainer>
  );
};
